import React, { useEffect } from 'react';
import { setSidebarVisibility } from 'reducers/ui';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useFindRouteMasterByIdQuery } from 'reducers/digitalmap/routeMaster/api';
import SplitPane from 'react-split-pane';
import Pane from 'react-split-pane/lib/Pane';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Spin } from 'antd';
import BaseMap from '../RouteMasterMap';
import Form from './RouteMasterForm';
import { useErrorHandler } from 'common_components/ErrorContext';

const RouteMasterDetails = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { setErrorData } = useErrorHandler();

  useEffect(() => {
    dispatch(setSidebarVisibility(false));
  }, [dispatch]);

  const { data, error, isFetching } = useFindRouteMasterByIdQuery(id, {
    skip: !id,
  });

  useEffect(() => {
    if (error) {
      setErrorData(error);
    }
  }, [error, setErrorData]);

  return (
    <SplitPane split='vertical'>
      <Pane initialSize='30%'>
        <div style={{ height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
          {isFetching === true ? (
            <RootCircular>
              <CenterSpin indicator={antIcon} size='large' />
            </RootCircular>
          ) : (
            <Form formData={data} />
          )}
        </div>
      </Pane>
      <Pane>
        <BaseMap />
      </Pane>
    </SplitPane>
  );
};
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const RootCircular = styled.div`
  display: table;
  height: calc(100%);
  margin: auto;
`;
const CenterSpin = styled(Spin)`
  display: table-cell;
  vertical-align: middle;
`;

export default RouteMasterDetails;
